export const defaultServiceTvanState = {
	regisHistory: [], //Danh sách lịch sử đăng ký
	Total: 0, //Tổng số bản ghi của lịch sử đăng ký
	taxPayRegisInfo: null, //Thông tin đăng ký nộp thuế
	taxDecRegisInfo: null, //Thông tin đăng ký khai thuế
	bankListByTaxCode: [], //Danh sách ngân hàng theo mst
	listDecTaxContactAdditional: [], //Danh sách liên hệ của khai thuế
	listPayTaxContactAdditional: [], //Danh sách liên hệ của nộp thuế
	isWaitingProcessDec: false, //Hồ sơ tờ khai có đang đăng kí thay đổi, bổ sung, ngừng không?
	isWaitingProcessPay: false, //Hồ sơ nộp thuế có tờ khai đang đăng kí thay đổi, bổ sung, ngừng không?
	isRegisServiceDeclareTax: false, // Đã đăng ký sử dụng dịch vụ khai thuế qua mạng,
	isRegisServicePayTax: false, //Đã đăng ký sử dụng dịch vụ nộp thuế qua mạng
	DecRegis: null, //Thông tin đăng ký dịch vụ khai thuế
	PayRegis: null, //Thông tin đăng ký dịch vụ nộp thuế
	isDecTaxCheckCompleted: false,
	isPayTaxCheckCompleted: false
};

export default {
	...defaultServiceTvanState
};
